<template>
  <v-menu min-width="250" bottom right v-if="hasLaunchers">
    <template v-slot:activator="{ on }">
      <v-btn icon dark v-on="on"><v-icon v-text="$vuetify.icons.values.launcher"></v-icon></v-btn>
    </template>
    <v-list>
      <v-list-item-content>
        <v-list-item-action>
          <v-icon light v-text="$vuetify.icons.values.launcher" class="fa-fw"></v-icon>
        </v-list-item-action>
        <v-list-item-content>
          <v-list-item-title>{{ $t('launcher') }}</v-list-item-title>
          <v-list-item-subtitle>{{ $t('launcherSubTitle') }}</v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item-content>
    </v-list>
    <v-divider></v-divider>
    <v-list>
      <div v-for="(item, index) in sortedLauncherItems" :key="index">
        <component :is="item.component"></component>
      </div>
    </v-list>
  </v-menu>
</template>

<script>
import { mapGetters } from 'vuex'
import { NAMESPACE } from '../store'

export default {
  computed: {
    ...mapGetters(NAMESPACE, ['sortedLauncherItems']),
    hasLaunchers() {
      return this.sortedLauncherItems.length > 0
    }
  }
}
</script>

<i18n>
{
  "en": {
    "launcher": "Launcher",
    "launcherSubTitle": "Select an application"
  },
  "fr": {
    "launcher": "Lanceur",
    "launcherSubTitle": "Choisissez une application"
  }
}
</i18n>
